import { responsiveFontSizes } from "@mui/material"
import { createTheme } from "@mui/material/styles"
import shadows from "./shadows"
import palette from "./palette"

const getTheme = (mode) =>
    responsiveFontSizes(
        createTheme({
            palette: palette(mode),
            layout: {
                contentWidth: "1236",
            },
            shadows: shadows(mode),
            typography: {
                fontFamily: '"Manrope", sans-serif',
                button: {
                    textTransform: "none",
                    fontWeight: "medium",
                },
            },
            zIndex: {
                appBar: 100,
                drawer: 1300,
            },
            components: {
                MuiButton: {
                    styleOverrides: {
                        label: {},
                        containedSecondary:
                            mode === "light" ? { color: "white" } : {},
                    },
                },
            },
        })
    )

export default getTheme
